import { useState } from "react";
import Stepper from "@/components/Stepper";
import { useParams } from "react-router-dom";
import IconButton from "@/components/IconButton";
import SkeletonElement from "@/components/Skeleton/SkeletonElement";
import { StepType } from "@/components/Stepper/Stepper";

const HistorySection = ({ stepsList, loading }: { stepsList: StepType[]; loading: boolean }) => {
  const { paymentId } = useParams();
  const [isExpanded, setIsExpanded] = useState(!!paymentId);

  const loadingStepsList = Array.from({ length: 3 }).map(() => ({
    headline: <SkeletonElement height="h-4" width="w-[200px]" rounded="rounded-full" className="animate-pulse" />,
    supportingText: <SkeletonElement height="h-4" width="w-20" rounded="rounded-full" className="animate-pulse mt-4" />
  }));

  if (loading) {
    return (
      <>
        <div className="flex items-center gap-2 pb-2 pt-12">
          <h3 className="text-title-large-bold font-serif">{`${paymentId ? "Payment" : "Order"} History`}</h3>
          <SkeletonElement height="h-3" width="w-10" rounded="rounded-full" className="animate-pulse" />
        </div>
        {isExpanded && (
          <div className="[&_*]:!cursor-default -mb-6">
            <Stepper variant="outlined" onStepClick={() => {}} stepsList={loadingStepsList} />
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <div className="flex items-center gap-2 pb-2 pt-12">
        <h3 className="text-title-large-bold font-serif">{`${paymentId ? "Payment" : "Order"} History (${
          stepsList.length
        })`}</h3>
        <IconButton
          name="expand_more"
          onClick={() => setIsExpanded(!isExpanded)}
          className={`transition-transform ${isExpanded ? "rotate-180" : ""}`}
          aria-label={isExpanded ? "Collapse section" : "Expand section"}
          skipMargin
        />
      </div>
      {stepsList.length > 0
        ? isExpanded && (
            <div className="[&_*]:!cursor-default -mb-6">
              <Stepper variant="outlined" onStepClick={() => {}} stepsList={stepsList} />
            </div>
          )
        : "No History Available"}
    </>
  );
};

export default HistorySection;
